import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Calendar } from 'primeng/calendar';
import { DatePickerModule } from 'primeng/datepicker';
import { catchError, forkJoin, of } from 'rxjs';
import { LeadService } from 'src/app/private/services/lead.service';
import { LeadActivityService } from 'src/app/private/services/micro-services/leadactivity.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-update-student-application-status',
  imports: [SharedModule, DatePickerModule],
  templateUrl: './update-student-application-status.component.html',
  styleUrl: './update-student-application-status.component.scss'
})
export class UpdateStudentApplicationStatusComponent {

  today: Date = new Date();
  createFieldFormValue: any = {};
  previousStudentData: any = {};
  isSubmitted: boolean = false;
  fieldValues: { [key: string]: any } = {};
  @Input() studentsList: any[] = [];
  @Input() userslist: any[] = [];

  @ViewChild('dobPicker') dobPicker!: Calendar;
  @Output() handleUpdateData = new EventEmitter<any>();

  @Input() fullUserList: any = [];
  @Input() fullCourseList: any = [];
  @Input() studentDetails: any = {};
  @Input() users: any = [];
  @Input() allLeadFeilds: any = [];

  accessObject: any = {};

  constructor(
    private api: LeadService,
    private localStorage: LocalStorageService,
    private messageService: MessageService,
    private leadActivityService: LeadActivityService
  ) {
    this.accessObject = this.localStorage.checkCRUDAccess('lead', 'manual');
  }

  isLoading: boolean = false;
  @Input() allCourses: any = [];

  leadSources: any[] = [
    { label: 'Channel Partner', value: 'Channel Partner' },
    { label: 'Conference', value: 'Conference' },
    { label: 'Field Visit', value: 'Field Visit' },
    { label: 'Google', value: 'Google' },
    { label: 'Instagram', value: 'Instagram' },
    { label: 'Lead Gen Tools', value: 'Lead Gen Tools' },
    { label: 'Live Session', value: 'Live Session' },
    { label: 'Personal', value: 'Personal' },
    { label: 'Referral', value: 'Referral' },
    { label: 'LinkedIn', value: 'LinkedIn' },
    { label: 'Website', value: 'Website' },
    { label: 'WhatsApp', value: 'WhatsApp' },
    { label: 'Tina', value: 'Tina' },
    { label: 'Intern', value: 'Intern' },
    { label: 'Other', value: 'Other' }
  ];

  genderOptions: any[] = [
    { label: 'Male', value: 'Male' },
    { label: 'Female', value: 'Female' },
    { label: 'Other', value: 'Other' }
  ];

  prefixOptions: any[] = [
    { label: 'Mr', value: 'Mr' },
    { label: 'Mrs', value: 'Mrs' },
    { label: 'Miss', value: 'Miss' },
    { label: 'Dr', value: 'Dr' },
    { label: 'Prof', value: 'Prof' }
  ];

  documentStatusList = [
    { label: 'Verified', value: 'verified' },
    { label: 'Pending', value: 'pending' },
    { label: 'Rejected', value: 'rejected' }
  ];

  applicationStatusList: any[] = [
    { value: 'In Progress', label: 'In Progress' },
    { value: 'Completed', label: 'Completed' },
    { value: 'Canceled', label: 'Canceled' }
  ];

  isFixedColumn: boolean = true;

  ngOnChanges(changes: SimpleChanges) {
    console.log("allCourses:", this.allCourses);
    console.log("Student Details Changes:", this.studentDetails);
    console.log("userslist", this.userslist);
    console.log("fullUserList", this.users);
    if (changes['studentDetails'] && changes['studentDetails'].currentValue) {
      this.createFieldFormValue = { ...this.studentDetails };
      this.fieldValues = this.studentDetails.dynamic_fields || {};
      
      // Convert date strings to Date objects
      this.createFieldFormValue.date_of_birth = this.studentDetails.date_of_birth
        ? new Date(this.studentDetails.date_of_birth)
        : null;

      // Ensure course_id is a string
      if (this.createFieldFormValue.course_id) {
        this.createFieldFormValue.course_id = this.createFieldFormValue.course_id.toString();
      }

      // Store previousStudentData AFTER all conversions
      this.previousStudentData = JSON.parse(JSON.stringify(this.createFieldFormValue));
      // Restore Date object after JSON.stringify
      if (this.createFieldFormValue.date_of_birth) {
        this.previousStudentData.date_of_birth = new Date(this.createFieldFormValue.date_of_birth);
      }
    }
  }

  ngOnInit() {
    if (this.studentDetails) {
      this.createFieldFormValue = { ...this.studentDetails };
      this.fieldValues = this.studentDetails.dynamic_fields || {};

      // Convert date strings to Date objects
      this.createFieldFormValue.date_of_birth = this.studentDetails.date_of_birth
        ? new Date(this.studentDetails.date_of_birth)
        : null;

      // Ensure course_id is a number
      if (this.createFieldFormValue.course_id) {
        this.createFieldFormValue.course_id = this.createFieldFormValue.course_id
      }

      // Store previousStudentData AFTER all conversions
      this.previousStudentData = JSON.parse(JSON.stringify(this.createFieldFormValue));
      // Restore Date object after JSON.stringify
      if (this.createFieldFormValue.date_of_birth) {
        this.previousStudentData.date_of_birth = new Date(this.createFieldFormValue.date_of_birth);
      }
    }

    console.log("allLeadFeilds", this.allLeadFeilds);
  }



  submitForm(isValid: any) {
    this.isSubmitted = true;

    if (!isValid) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please fill all the required fields' });
      return;
    }

    console.log("createFieldFormValue: ", this.createFieldFormValue);
    console.log("previousStudentData: ", this.previousStudentData);

    this.isLoading = true;
    this.createFieldFormValue.dynamic_fields = this.fieldValues;

    // Check if guardian fields changed (registration-related)
    const guardianFieldsChanged = 
      (this.createFieldFormValue.guardian_name !== this.previousStudentData.guardian_name ||
       this.createFieldFormValue.guardian_contact !== this.previousStudentData.guardian_contact);

    // Check if lead fields changed (excluding guardian fields)
    const leadFieldsChanged = 
      this.createFieldFormValue.prefix !== this.previousStudentData.prefix ||
      this.createFieldFormValue.first_name !== this.previousStudentData.first_name ||
      this.createFieldFormValue.last_name !== this.previousStudentData.last_name ||
      this.createFieldFormValue.email !== this.previousStudentData.email ||
      this.createFieldFormValue.phone !== this.previousStudentData.phone ||
      this.createFieldFormValue.alternate_phone !== this.previousStudentData.alternate_phone ||
      this.createFieldFormValue.date_of_birth?.getTime() !== this.previousStudentData.date_of_birth?.getTime() ||
      this.createFieldFormValue.age !== this.previousStudentData.age ||
      this.createFieldFormValue.gender !== this.previousStudentData.gender ||
      this.createFieldFormValue.nationality !== this.previousStudentData.nationality ||
      this.createFieldFormValue.address !== this.previousStudentData.address ||
      this.createFieldFormValue.city !== this.previousStudentData.city ||
      this.createFieldFormValue.state !== this.previousStudentData.state ||
      this.createFieldFormValue.country !== this.previousStudentData.country ||
      this.createFieldFormValue.postal_code !== this.previousStudentData.postal_code ||
      this.createFieldFormValue.source !== this.previousStudentData.source ||
      this.createFieldFormValue.preferred_location !== this.previousStudentData.preferred_location ||
      this.createFieldFormValue.interested_course !== this.previousStudentData.interested_course ||
      this.createFieldFormValue.course_id !== this.previousStudentData.course_id ||
      this.createFieldFormValue.assign_to !== this.previousStudentData.assign_to ||
      this.createFieldFormValue.status !== this.previousStudentData.status ||
      this.createFieldFormValue.document_status !== this.previousStudentData.document_status ||
      this.createFieldFormValue.remarks !== this.previousStudentData.remarks ||
      JSON.stringify(this.createFieldFormValue.dynamic_fields || {}) !== JSON.stringify(this.previousStudentData.dynamic_fields || {});

    // If lead fields or guardian fields changed, call updateLead API
    if (leadFieldsChanged || guardianFieldsChanged) {
      const leadPayload: any = {
        current_stage: 'application',
        lead_id: this.createFieldFormValue.lead_id,
        organization_id: this.createFieldFormValue.organization_id,
        user_id: this.createFieldFormValue.user_id,
        prefix: this.createFieldFormValue.prefix,
        first_name: this.createFieldFormValue.first_name,
        last_name: this.createFieldFormValue.last_name,
        email: this.createFieldFormValue.email,
        phone: this.createFieldFormValue.phone,
        alternate_phone: this.createFieldFormValue.alternate_phone,
        date_of_birth: this.createFieldFormValue.date_of_birth,
        age: this.createFieldFormValue.age,
        gender: this.createFieldFormValue.gender,
        nationality: this.createFieldFormValue.nationality,
        address: this.createFieldFormValue.address,
        city: this.createFieldFormValue.city,
        state: this.createFieldFormValue.state,
        country: this.createFieldFormValue.country,
        postal_code: this.createFieldFormValue.postal_code,
        source: this.createFieldFormValue.source,
        preferred_location: this.createFieldFormValue.preferred_location,
        interested_course: this.createFieldFormValue.interested_course,
        course_id: this.createFieldFormValue.course_id,
        assign_to: this.createFieldFormValue.assign_to,
        status: this.createFieldFormValue.status,
        document_status: this.createFieldFormValue.document_status,
        remarks: this.createFieldFormValue.remarks,
        dynamic_fields: this.createFieldFormValue.dynamic_fields,
        old_lead_data: this.previousStudentData,
        user: this.users.find((user: any) => user.user_id === this.createFieldFormValue.user_id) || {}
      };

      // If guardian fields changed, include registration data
      if (guardianFieldsChanged) {
        // New guardian data in registration object
        leadPayload.reg_data = {
          reg_id : this.createFieldFormValue.reg_id,
          organization_id: this.createFieldFormValue.organization_id,
          user_id: this.createFieldFormValue.user_id,
          campus_id: this.createFieldFormValue.campus_id,
          guardian_name: this.createFieldFormValue.guardian_name,
          guardian_contact: this.createFieldFormValue.guardian_contact
        };
        
        // Previous guardian data in reg_data
        leadPayload.registration = {
          reg_id : this.previousStudentData.reg_id,
          organization_id: this.previousStudentData.organization_id,
          user_id: this.previousStudentData.user_id,
          campus_id: this.previousStudentData.campus_id,
          guardian_name: this.previousStudentData.guardian_name,
          guardian_contact: this.previousStudentData.guardian_contact
        };
      }

      this.api.updateLead(leadPayload).subscribe({
        next: (response) => {
          this.isLoading = false;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Student details updated successfully' });
          this.handleUpdateData.emit(this.createFieldFormValue);
          this.previousStudentData = JSON.parse(JSON.stringify(this.createFieldFormValue));
          // Restore Date objects after JSON.stringify
          if (this.createFieldFormValue.date_of_birth) {
            this.previousStudentData.date_of_birth = new Date(this.createFieldFormValue.date_of_birth);
          }
          this.isSubmitted = false;
        },
        error: (err) => {
          console.log('Error updating student details:', err);
          this.isLoading = false;
          this.isSubmitted = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update student details.' });
        }
      });
      return;
    }

    // If no changes detected
    this.isLoading = false;
    this.isSubmitted = false;
    this.messageService.add({ severity: 'info', summary: 'Info', detail: 'No changes detected' });
  }

}
